import { useState } from "react";
import React from "react";
import { connect } from 'react-redux';
import * as actions from "store/actions";
import Button from "components/CustomButtons/Button";
import Notification from "components/Notification/Notification";
import NotificationAsk from "components/Notification/NotificationAsk";
import { get } from "lodash";
import Loader from "components/Loader/Loader";
import axios from "store/axios/axios-files";
import { downloadFile, formatDate2, handleError, makeid } from "../../shared/utility";
import { IconButton } from "@material-ui/core";
import CustomSimpleDialog from "../CustomDialog/CustomSimpleDialog";
import Inputt from "../CustomInput/Inputt";
import TableSmall from "../Table/TableSmall";
import moment from "moment";
import { useEffect } from "react";
import { getPropertyFiles } from "../../containers/CRM/Properties/PropertiesLogic";

function isPdfOrImage(filename) {
  const lower = filename.toLowerCase();
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
  const pdfExtension = '.pdf';

  if (lower.endsWith(pdfExtension)) {
    return 'pdf';
  }

  if (imageExtensions.some(ext => lower.endsWith(ext))) {
    return 'image';
  }

  return null; // Not a supported file type
}


// REQUIRED PROPS
// --------------
// update - function
// remove - function
// field - string field name
// the_filename <optional>
// type = "crm" or "rs"

const FileUploader = (props) => {
    const [file, setFile] = useState(null);
    const [notification, setNotification] = useState('');
    const [ask, setAsk] = useState(false);
    const [loading, setLoading] = useState(false);
    const [notes, setNotes] = useState('');
    const [files, setFiles] = useState([]);
    const [loadingFile, setLoadingFile] = useState(null);
    const [openedChooseFiles, setOpenedChooseFiles] = useState(false);
    const [inputVal, setInputVal] = useState('');
    const [filenamesFilter, setFilenamesFilter] = useState([]);
    const [filterByPropertyID, setFilterByPropertyID] = useState(false);

    const {
        accept = ".pdf, .png, .jpg, .jpeg, .webp, application/pdf, image/png, image/jpeg, image/webp"
    } = props;

    const handleChange = (event) => {
        const e = event;
        const selectedFile = e.target.files[0];
        if (selectedFile && selectedFile.size > 100 * 1024 * 1024) {
            alert('File is too large! Maximum allowed size is 100MB.');
            e.target.value = null; // Clear file input
            setFile(null);
            return;
        }
        setFile(event.target.files[0])
    }

    const downloadTheFile = async (actiondata) => {
        try {
            const string_obj = JSON.stringify(actiondata);
            setLoadingFile(string_obj);
            const response = await axios.get('/download?id='+
                actiondata.id+'&type='+
                actiondata.type, {responseType: 'blob'});
            setLoadingFile(null);
            downloadFile(response);
        } catch(e) {
            alert('There was a problem downloading your file, please try again and if the issue persists please call tech support.');
            setLoadingFile(null);
            handleError(e);
        }
    }

    const viewTheFile = async (actiondata) => {
        try {
            const string_obj = JSON.stringify(actiondata);
            setLoadingFile(string_obj);
            const response = await axios.get('/download?id='+
                actiondata.id+'&type='+
                actiondata.type, {responseType: 'blob'});
            setLoadingFile(null);
            const blobUrl = URL.createObjectURL(response.data);
            window.open(blobUrl, '_blank');
        } catch(e) {
            alert('There was a problem downloading your file, please try again and if the issue persists please call tech support.');
            setLoadingFile(null);
            handleError(e);
        }
    }

    const loadOwnFiles = async () => {
        setLoading(true);
        setFiles([]);
        try {
            const response = await axios.get('/data?own=true');
            console.log('loaded files', response.data);
            if (response.data.length === 0) {
                setNotification('No existing files found');
            }
            setFiles(response.data);
        } catch(e) {
            handleError(e);
            setNotification('error getting files, please try again');
        }
        setLoading(false);
    }

    const uploadFile = async (data) => {
        setLoading(true);
        try {
            const formData = new FormData();
            const originalname = data.file.name;
            const newname = `${makeid(5)}-${originalname}`;
            formData.append("file", data.file, newname);
            formData.append("sfiletype", data.type);
            formData.append("notes", data.notes ? data.notes : '');
            const response = await axios.post('/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const rdata = response.data;
            const file_uploaded = get(rdata, 'file_data', null);
            const date_file_uploaded = get(rdata, 'date_created', null);
            const notes = get(rdata, 'notes', '');
            setNotes(notes);
            props.update(`${file_uploaded},${date_file_uploaded}`);
        } catch(e) {
            console.log(e);
            setNotification('error uploading, please try again');
        }
        setLoading(false);
        setFile(null);
    }

    let the_file = '';
    let the_id = '';
    let the_date = '';
    const the_filename = get(props, 'the_filename', null);
    if (the_filename) {
        const the_arr = the_filename.split(',')
        if (the_arr.length > 1) {
            the_file = the_arr[1];
            the_id = the_arr[0];
            the_date = the_arr[2] ? the_arr[2] : '';
        }
    }

    const pdf_or_image = the_file ? isPdfOrImage(the_file) ? true : false : false;
    
    if (loading) return <div style={{margin:10}}><Loader /></div>;

    const getThePropertyFiles = async (property_id) => {
        const files_for_filter = await getPropertyFiles(property_id);
        setFilenamesFilter(files_for_filter);
    }

    console.log('FileUploader', props, filenamesFilter);

    const filterFunction = f => {
        if (props.property_id_filter && filterByPropertyID) {
            if (!f.filename) return false;
            const included = new Set(filenamesFilter.map(f => {
                return f;
            }));
            // const lowerIncluded = new Set(filenamesFilter.map(f => f.toLowerCase()));
            const lowerName = f.filename.toLowerCase();
            const lowerInput = inputVal ? inputVal.toLowerCase() : inputVal;
            console.log('checking', included, f.filename);
            return included.has(f.filename) &&
                (lowerInput === '' || lowerName.includes(lowerInput));
        } else {
            console.log('filterings..');
            let pass = true;
            if (inputVal) {
                if (f.filename) {
                    const lower = inputVal.toLowerCase();
                    const lower2 = f.filename.toLowerCase();
                    if (lower2.indexOf(lower) !== -1) {
                        pass = true;
                        return pass;
                    }
                }
                pass = false;
                return pass;
            }
            return pass;
        }   
    }

    const files_filtered = files.filter(filterFunction);

    return <div style={{position:'relative'}}>
        {props.title && <h4 style={{fontSize:15,fontWeight:'bold'}}>{props.title}</h4>}
        <hr style={{width:100}} />
        {(!the_file && props.update && !props.disabled) && <div>
            <div style={{marginBottom:10}}><input 
                type="file"
                onChange={handleChange}
                style={{width:'100%'}}
                accept={accept}
            /></div>
            {file && <Button size={props.button_size ? 'lg' : 'sm'} color="rose" className="mr-20" onClick={() => {
                uploadFile({
                    type: props.type,
                    file
                })
            }}>UPLOAD</Button>}
            {props.close && <Button color="white" onClick={() => {
                props.close();
            }}>CANCEL</Button>}
        </div>}

        {(!the_file && props.update && !props.disabled) && <div>
            <div style={{marginBottom:10}}>
                <Button color="primary" size="sm"
                    onClick={() => {
                        // load
                        setOpenedChooseFiles(true)
                        loadOwnFiles();
                        if (props.property_id_filter) {
                            // get files associated with this property ID 
                            getThePropertyFiles(props.property_id_filter);
                            setFilterByPropertyID(true);
                        }
                    }}
                >CHOOSE EXISTING FILE</Button>
            </div>
        </div>}
        {the_file && <div>
        {(props.remove && !props.disabled) && <div style={{position:'absolute',top:'-11px',right:5}}><i className="fa fa-trash red-text hoverable" style={{float:'right'}} onClick={() => {
            setAsk(true);
        }}></i></div>}

        {the_file && <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-file-earmark" viewBox="0 0 16 16">
                <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z"/>
            </svg>
        </div>}

        {!props.hide_filename && <div style={{overflow:'hidden'}}><em>
            {the_file ? the_file.substring(the_file.indexOf("-") + 1) : ''}
        </em></div>}
        {(!props.hide_date && the_date) && <div style={{overflow:'hidden'}}><em><small>Uploaded {the_date}</small></em></div>}
        
        {loadingFile && <Loader />}
        {!loadingFile && <IconButton style={{marginRight:20}} onClick={() => {
            downloadTheFile({ id:the_id, type: props.type ? props.type : 'crm' });
        }}><i className="fa fa-arrow-down red-text"></i></IconButton>}

        {(!loadingFile && pdf_or_image) && <IconButton onClick={() => {
            viewTheFile({ id:the_id, type: props.type ? props.type : 'crm' });
        }}><i className="fa fa-eye red-text"></i></IconButton>}
        </div>}

        {(props.required && !the_file) && <div className="red-text"><small>Required</small></div>}

        {notification && <Notification 
            open={notification ? true : false}
            close={() => { setNotification(''); }}
            message={notification}
        />}

        {ask && <NotificationAsk 
            open={ask}
            close={() => { setAsk(false) }}
            title="Are you sure?"
            message={`Do you want to remove this file "${the_file}" ?`}
            success={() => {
                props.remove();
                setAsk(false);
            }}
        />}

        {(openedChooseFiles && files.length > 0) && <CustomSimpleDialog 
            open={true}
            close={() => {
                setOpenedChooseFiles(false);
            }}
            no_ok_button={true}
            content={<div style={{maxWidth:800}}>
                <h3>Choose file {filterByPropertyID ? 'uploaded in the Property' : ''}</h3>
                {props.property_id_filter && <Button 
                    color={filterByPropertyID ? 'primary' : 'white'}
                    onClick={() => {
                        if (filterByPropertyID) {
                            setFilterByPropertyID(false);
                        } else {
                            setFilterByPropertyID(true);
                            getThePropertyFiles(props.property_id_filter);
                        }
                    }}
                >{filterByPropertyID ? `SHOW ALL FILES` : 'FILTER BY PROPERTY FILES' }
                </Button>}
                <Inputt 
                    onChange={(e) => {
                        setInputVal(e.target.value);
                    }}  
                    value={inputVal}
                    label="Search by Filename"
                />
                {files_filtered.length === 0 && filterByPropertyID ? <div><em>No property related files already uploaded</em></div> 
                    : ''}
                <div style={{height:500,overflow:'auto'}} className="hover-table">
                    <TableSmall 
                        tableHead={[<strong>Filename</strong>,
                                <strong>Date Created</strong>,
                                <strong>Action</strong>]}
                        tableData={files_filtered.map(f => {
                            const obj = { id:f.id, type: props.type ? props.type : 'crm' };
                            const string_obj = JSON.stringify(obj);
                            return [
                                f.filename ? f.filename.substring(f.filename.indexOf("-") + 1) : '',
                                formatDate2(f.date_created),
                                <div>
                                    {(loadingFile === string_obj) && <Loader />}
                                    {(loadingFile !== string_obj) && <IconButton style={{marginRight:20}}
                                        onClick={() => {
                                            downloadTheFile({ id:f.id, type: props.type ? props.type : 'crm' });
                                        }}
                                    >
                                        <i className="fa fa-arrow-down red-text"></i>
                                    </IconButton>}
                                    {(loadingFile !== string_obj) && <IconButton style={{marginRight:20}}
                                        onClick={() => {
                                            viewTheFile({ id:f.id, type: props.type ? props.type : 'crm' });
                                        }}
                                    >
                                        <i className="fa fa-eye red-text"></i>
                                    </IconButton>}
                                    <Button size="sm" color="primary"
                                        onClick={() => {
                                            const file_uploaded = `${f.id},${f.filename}`;
                                            const date_file_uploaded = moment().format('MM/DD/YYYY');
                                            props.update(`${file_uploaded},${date_file_uploaded}`);
                                            setOpenedChooseFiles(false);
                                        }}
                                    >CHOOSE</Button>
                                </div>
                            ]
                        })}
                    />
                </div>
                <Button color="white" onClick={() => {
                    setOpenedChooseFiles(false);
                }}>CANCEL</Button>
            </div>}
        />}
    </div>
}

const mapStateToProps = state => {
    return {
        loading: state.files.loading,
        error_upload: state.files.error_upload,
        success_upload: state.files.success_upload,
        file_uploaded: state.files.file_uploaded,
        date_file_uploaded: state.files.date_file_uploaded
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        createFileUpload: (data) => {
            dispatch(actions.createFileUpload(data));
        },
        getFileUpload: (data) => {
            dispatch(actions.getFileUpload(data));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FileUploader);